import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { Util, Principal, createIcon, Request, Notification } from "../common";
import Badge from './Badge';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { UIComponent } from './Base';
import { auth } from 'codeArt/auth';

export class MenuRoot extends React.Component {
   
  constructor(props) {
      super(props);
  }

  render() {
     return this.props.children; 
  }
}


export class MenuItem extends UIComponent {
   
  constructor(props) {
      super(props);
      this.state={};
      let badge = props.badge;
      if(badge && badge.event){
        this.on = (arg) => {
          if(arg.source == badge.event){
            this.load();
          }
        };
      }
  }

  componentWillMount(){
    super.componentWillMount();
    this.load();
  }

  load(){
    let {badge} = this.props;
    if(!badge) return;
    let p = badge;
    Request({
      ...p,
      before:()=>{

      },
      complete:()=>{

      },
      success:(r)=>{
        if (this.isUnmounted()) return; //防止数据没加载完用户就取消浏览，导致的bug
        let value = p.success(r);
        this.setState({badgeValue:value});
      },
      error:(msg)=>{
        Notification.error(msg);
      }
    });
  }

  renderBage(){
    let {badge,badgeColor} = this.props;
    if(!badge) return null;
    let value = this.state.badgeValue;
    return value ?<Badge color={badgeColor} size="sm">{value}</Badge>:null;
  }

  auth(){
    return authMenuItem(this.props);
  }

  renderContent(){
    let {children,icon,badge} = this.props;
    if(Util.type(badge) != "object"){
      badge = {value:badge,color:"danger"};
    }
    icon=createIcon(icon,`zmdi-hc-fw c-mr-2d5`);

    return (
      <span className="d-flex flex-row justify-content-start align-items-center">
          {icon}
          <span className="d-flex flex-row justify-content-between align-items-center c-flex-1">
            <span className="nav-text">{children}</span>
            {this.renderBage()}
          </span>
        </span>
    );
  }

  render() {
      let {to,className,linkClassName,blank} = this.props;
      return (
        this.auth()?
        <li className={className}>
          {blank?
            <a href={to} target="_blank">
              {this.renderContent()}
            </a>
          :
          <NavLink className={linkClassName} to={to}>
            {this.renderContent()}
          </NavLink>
          }
        </li>:null
      )
  }
}

function authMenuItem(props){
  let {permission,permissionData,role,dark} = props;
  return auth({permission,permissionData,role,dark});
}

MenuItem.defaultProps={
  className:'',
  linkClassName:'',
  badgeColor:"danger"
}

export class Menu extends React.Component {
   
  constructor(props) {
      super(props);
  }

  auth(){
    return authVisibility(this.props)
  }
  
  render() {
      let {children,icon,title} = this.props;
      if(!icon) icon = AccountBoxIcon;
      icon = createIcon(icon,'zmdi-hc-fw c-mr-2d5');
      return (
        this.auth() ?
          <li className="menu collapse-box">
            <Button>
              <span className="d-flex flex-row justify-content-start align-items-center c-flex-1">
              {icon}
              <span className="nav-text">
                {title}
              </span>
              </span>
            </Button>
            <ul className="sub-menu">
              {children}
            </ul>
          </li>
        : null
      )
  }
}

Menu.defaultProps = {
  
}

function authVisibility(props){
  if(!props) return true;//没有配置属性，那是可以显示的正常元素
  let {permission,permissionData,role,dark} = props;
  let self = auth({permission,permissionData,role,dark});
  if(!self) return false;

  //验证子项
  let {children} = props;
  children = React.Children.toArray(children);
  if(!children || children.length===0) return true;  //没有子项，那么可以显示

  for(let i=0;i<children.length;i++){
    let c = children[i];
    if(authVisibility(c.props)) return true; //只要有一个子项可以访问，那么可见
  }
  return false;
}

// function authMenu(props){
//   let {permission,permissionData,role,dark} = props;
//   return auth({permission,permissionData,role,dark}) && authMenuChildren(props);
// }

// function authMenuChildren(props){
//   let {children} = props;
//   children = React.Children.toArray(children);

//   for(let i=0;i<children.length;i++){
//     let c = children[i];
//     let type = Util.type(c);
//     if(type==="MenuItem"){
//       let auth = authMenuItem(c.props);
//       if(auth) return true;
//     }
//     else {//不是验证性元素，直接显示
//       return true;
//     }
//   }
//   return false;
// }


export class MenuGroup extends React.Component {
   
  constructor(props) {
      super(props);
  }

  render() {
      let {title,children,permission,permissionData,role,dark} = this.props;
      return (
        authVisibility({permission,permissionData,role,dark,children}) ?
        [
          <li key={0} className="nav-header">{title}</li>,
          children
        ] : null
      )
  }
}

MenuGroup.defaultProps = {
  
}